<ng-container>
    <app-menu *ngIf="!showOnlyTemplate; else onlyTemplate"></app-menu>

    <ng-template #onlyTemplate>
        <router-outlet></router-outlet>
    </ng-template>
</ng-container>

<app-language-switcher
        *ngIf="showLanguageSwitcher"
        [uuid]="uuidUrl"
        class="app-language-switcher--overlay">
</app-language-switcher>

<app-global-loading></app-global-loading>